//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/View.js";
import "../no/Display.js";
let d=[[[0,"ActiveDynamicSection",1,"Display.DynamicSection",0],[0,"DisplaySectioningToggle",1,0],[0,"IsMirrored",0,0]],[[[],"UseDefaultLights",{},0,0],[[],"UseSceneLights",{},0,0],[["dynamicSection"],"IsDynamicSectionVisible",{R_:{visible:''}},1,0],[["dynamicSection","visible"],"SetDynamicSectionVisible",{},2,0],[["expand"],"ExpandCollapseNode",{},1,0]],[["HiqhQualityImage","ModelingViewHighQualityImage",0]]];
SPLM.ModelingView = class extends SPLM.View{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ModelingView";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;